/**
 * 라우트 상수 정의
 * - 경로 중앙 관리
 * - 타입 안전성 보장
 */

export const ROUTES = {
  // 인증 관련
  LOGIN: '/login',

  // 대시보드
  DASHBOARD: '/dashboard',
  HOME: '/',

  // 회원 관리
  MEMBERS: '/members',
  MEMBER_DETAIL: (userSeq: string) => `/members/${userSeq}`,

  // 사업자 관리
  BUSINESS: '/business',

  // 매출 (본사 실매출)
  REVENUE: '/revenue',

  // 결제 및 정산 정보 — 하위 메뉴
  PAYMENT: '/payment',
  PAYMENT_CREDIT: '/payment/credit',
  PAYMENT_ONLINE: '/payment/online',
  PAYMENT_OFFLINE: '/payment/offline',

  // 정산 관리
  SETTLEMENT: '/settlement',
  SETTLEMENT_DETAIL: (id: string, yearMonth: string) =>
    `/settlement/${encodeURIComponent(id)}/${encodeURIComponent(yearMonth)}`,

  // 알림 관리
  NOTIFICATIONS: '/notifications',
  NOTIFICATION_SEND: '/notifications/send',
  NOTIFICATION_DETAIL: (id: string) => `/notifications/${id}`,

  // 공지사항 (시스템 업데이트 공지)
  ANNOUNCEMENTS: '/announcements',
  ANNOUNCEMENT_NEW: '/announcements/new',
  ANNOUNCEMENT_DETAIL: (id: string | number) => `/announcements/${id}`,
  ANNOUNCEMENT_EDIT: (id: string | number) => `/announcements/${id}/edit`,

  // 홈 배너
  BANNERS: '/banners',
  BANNER_NEW: '/banners/new',
  BANNER_EDIT: (id: string | number) => `/banners/${id}/edit`,

  // 약관 관리 (버전 단위)
  TERMS: '/terms',
  TERMS_NEW: '/terms/new',
  TERMS_DETAIL: (id: string | number) => `/terms/${id}`,
  TERMS_EDIT: (id: string | number) => `/terms/${id}/edit`,

  // Push 발송
  PUSH_MESSAGES: '/push-messages',
  PUSH_MESSAGE_NEW: '/push-messages/new',

  // 앱 버전 정책
  APP_VERSION_POLICIES: '/app-version-policies',

  // 예약 관리
  DAILY_RESERVATIONS: '/daily-reservations',

  // 이용권 관리
  TICKETS: '/tickets',

  // 사업자 메뉴 관리
  BUSINESS_MENU: '/business-menu',

  // 크레딧 관리
  CREDIT: '/credit',
  CREDIT_DASHBOARD: '/credit/dashboard',
  CREDIT_PRICES: '/credit/prices',
  CREDIT_POLICIES: '/credit/policies',
  CREDIT_PACKAGES: '/credit/packages',
  CREDIT_COMPANIES: '/credit/companies',
  CREDIT_BULK_GRANT: '/credit/bulk-grant',
  CREDIT_CHANGES: '/credit/changes',

  // 활동 로그 (도메인 이벤트)
  BUSINESS_LOGS: '/business-logs',
  GUARDIAN_LOGS: '/guardian-logs',

  // API 감사 로그
  AUDIT_LOGS: '/audit-logs',

  // 조건 설정 — 최상위 (운영 정책 통합 진입점)
  CONDITIONS: '/conditions',
  CONDITIONS_CREDIT: '/conditions/credit',

  // 알림톡 템플릿 관리
  KAKAO_ALIM_TEMPLATES: '/kakao-alim/templates',

  // API 테스트
  API_TEST: '/api-test',
} as const;

/**
 * 라우트 타입 정의
 */
export type RouteKey = keyof typeof ROUTES;

/**
 * 보호된 라우트 목록
 */
export const PROTECTED_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.MEMBERS,
  ROUTES.BUSINESS,
  ROUTES.PAYMENT,
  ROUTES.PAYMENT_CREDIT,
  ROUTES.PAYMENT_ONLINE,
  ROUTES.PAYMENT_OFFLINE,
  ROUTES.SETTLEMENT,
  ROUTES.NOTIFICATIONS,
  ROUTES.NOTIFICATION_SEND,
  ROUTES.ANNOUNCEMENTS,
  ROUTES.ANNOUNCEMENT_NEW,
  ROUTES.BANNERS,
  ROUTES.BANNER_NEW,
  ROUTES.TERMS,
  ROUTES.TERMS_NEW,
  ROUTES.PUSH_MESSAGES,
  ROUTES.PUSH_MESSAGE_NEW,
  ROUTES.APP_VERSION_POLICIES,
  ROUTES.DAILY_RESERVATIONS,
  ROUTES.TICKETS,
  ROUTES.BUSINESS_MENU,
  ROUTES.CREDIT,
  ROUTES.CREDIT_DASHBOARD,
  ROUTES.CREDIT_PRICES,
  ROUTES.CREDIT_POLICIES,
  ROUTES.CREDIT_PACKAGES,
  ROUTES.CREDIT_COMPANIES,
  ROUTES.CREDIT_BULK_GRANT,
  ROUTES.CREDIT_CHANGES,
  ROUTES.BUSINESS_LOGS,
  ROUTES.GUARDIAN_LOGS,
  ROUTES.AUDIT_LOGS,
  ROUTES.API_TEST,
] as const;

/**
 * 공개 라우트 목록
 */
export const PUBLIC_ROUTES = [ROUTES.LOGIN] as const;
